module.exports = "<!--[attr.cx]=\"point.x\" [attr.cy]=\"point.y\" r=\"2\" fill=\"#000000\" stroke=\"#222222\" stroke-width=\"0\"-->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/widgets/widget-detail/map-editor/region-point.component.html
// module id = ./src/app/widgets/widget-detail/map-editor/region-point.component.html
// module chunks = main